import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import Select, { StyledExpansitionIconContainer } from 'UIKit/Select'
import Text from 'UIKit/Text'
import { RowMiddle } from 'layout/Components/Row'
import React, { useMemo } from 'react'
import { Trans } from 'react-i18next'
import styled from 'styled-components'
import { GameFilterOptionType } from './config'

type GameFilterProps = {
  selectedOption: GameFilterOptionType
  onSelectOption: (option: GameFilterOptionType) => void
  filterOptions: GameFilterOptionType[]
}

const GamesFilter: React.FC<GameFilterProps & BoxProps> = ({
  selectedOption,
  onSelectOption,
  filterOptions,
  ...props
}) => {
  const options = useMemo(
    () => (selectedOption ? filterOptions.filter((item) => item.key !== selectedOption.key) : filterOptions),
    [filterOptions, selectedOption],
  )

  return (
    <WrapperFilter minWidth={['120px', '120px', '140px']} {...props}>
      <StyledSelect
        options={options}
        onSelect={onSelectOption}
        OptionItemComponent={OptionItem}
        dropdownContentProps={{
          className: 'select-dropdown',
        }}
        className="select-container"
      >
        {selectedOption && (
          <Text fontSize="12px" color="textSubtle" fontWeight={500}>
            <Trans>{selectedOption.value}</Trans>
          </Text>
        )}
      </StyledSelect>
    </WrapperFilter>
  )
}

const OptionItem: React.FC<{ item: GameFilterOptionType }> = ({ item }) => {
  return (
    <RowMiddle px="4px">
      <Text fontSize="12px" color="textSubtle" fontWeight={400}>
        <Trans>{item.value}</Trans>
      </Text>
    </RowMiddle>
  )
}

export const StyledSelect = styled(Select)`
  padding: 8px 10px;
  ${StyledExpansitionIconContainer} {
    padding: 0;
  }

  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.buttonBackgroundAlt3};
`

export const WrapperFilter = styled(Box)`
  ${StyledExpansitionIconContainer} {
    margin: 0;
  }
  .select-dropdown {
    box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.4);
    background: var(
      --Dark-Dark-6,
      linear-gradient(0deg, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0.04) 100%),
      #16191f
    );
  }
`

export default GamesFilter
